import { render, staticRenderFns } from "./CustomFieldsDetails.vue?vue&type=template&id=1a823308&"
import script from "./CustomFieldsDetails.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a823308')) {
      api.createRecord('1a823308', component.options)
    } else {
      api.reload('1a823308', component.options)
    }
    module.hot.accept("./CustomFieldsDetails.vue?vue&type=template&id=1a823308&", function () {
      api.rerender('1a823308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/CustomFieldsDetails.vue"
export default component.exports